import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {Grid,Backdrop} from '@material-ui/core';
import NotybotImg from 'assets/images/notybot/notybot_loading.png'
import {isUndefined} from 'lodash'

const useStyles = makeStyles((theme) => ({
  loading: {
    backgroundColor: '#00000061',
    zIndex: 10000,
    backdropFilter: 'blur(3px)',
    width: "110%"
  },
  wiggleImage: {
    animation: `$wiggle 1500ms infinite`,
    height: 90
  },
  "@keyframes wiggle": {
    "0%": { transform: 'rotate(0deg);' },
   "80%": { transform: 'rotate(0deg);' },
   "85%": { transform: 'rotate(5deg);' },
   "95%":{ transform: 'rotate(-5deg);' },
  "100%":{ transform: 'rotate(0deg);' }
  }
}));

export default function Loading({message, center}) {
  const classes = useStyles();
  return (
    <Grid
    container
    direction="row"
    justify="center"
    alignItems="center"
        >
        <Backdrop className={classes.loading} open={true} style={{width: isUndefined(center) ? '100%' : center ? '100%' : '110%'}}>
          <div className="d-flex flex-column align-items-center justify-content-center">
       <img src={NotybotImg} className={classes.wiggleImage}/>
        <h2 style={{ fontWeight: 500, marginTop: '3px !important', color: 'rgb(255 255 255)'}}>{message}</h2>
        </div>
       
       </Backdrop>
      </Grid>
  )
}
